module.exports = __webpack_public_path__ + "static/media/karen_burrows.44d82dc8.webp";